module.exports = __webpack_public_path__ + "img/schedule.1eb42dab.svg";